<div class="form-field-flex" >
    <mat-icon svgIcon="mat_outline:search"></mat-icon>
    <input class="input-field flex grow"
           placeholder="Pesquisa em acervo consultivo"
           [formControl]="content"
           (keydown.enter)="onSearchConsultiva($event)"
           [(ngModel)]="searchQuery"
    >
</div>
